import './App.css';
import React, { Suspense, lazy, useEffect } from 'react';
import NavBar from './components/NavBar';
// Custom Bootstrap with yellow primary color (#FEA116)
import './css/bootstrap.min.css';

import './lib';

import './css/style.css';
import { Toaster } from 'react-hot-toast';

// Lazy load components below the fold for better initial load performance
const Service = lazy(() => import('./components/Service'));
const AboutUs = lazy(() => import('./components/AboutUs'));
const Menu = lazy(() => import('./components/Menu'));
const DietSection = lazy(() => import('./components/Treasure'));
const MembershipSection = lazy(() => import('./components/Membership'));
const SpecialOrderSection = lazy(() => import('./components/SpecialOrder'));
const FooterSection = lazy(() => import('./components/Footer'));

// Loading fallback component
const LoadingFallback = () => (
  <div className="text-center py-5">
    <div className="spinner-border text-primary" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>
);

// Lazy load Bootstrap JS and initialize scroll animations after initial render
const loadHeavyLibraries = async () => {
  // Load Bootstrap JS bundle asynchronously after a short delay
  // This allows the initial render to complete first
  setTimeout(() => {
    import('bootstrap/dist/js/bootstrap.bundle.min.js').catch(() => {
      // Bootstrap already loaded or failed - continue
    });
  }, 100);

  // Initialize lightweight scroll animations after DOM is ready
  setTimeout(async () => {
    const { initScrollAnimations } = await import('./lib/scrollAnimations');
    initScrollAnimations();
  }, 300);
};

function App() {
  useEffect(() => {
    // Load heavy libraries after component mounts
    loadHeavyLibraries();
  }, []);

  return (
    <>
      <Toaster position="top-right" />
      <NavBar />
      <Suspense fallback={<LoadingFallback />}>
        <Service />
      </Suspense>
      <Suspense fallback={null}>
        <AboutUs />
      </Suspense>
      <Suspense fallback={null}>
        <Menu />
      </Suspense>
      <Suspense fallback={null}>
        <DietSection />
      </Suspense>
      <Suspense fallback={null}>
        <MembershipSection />
      </Suspense>
      <Suspense fallback={null}>
        <SpecialOrderSection />
      </Suspense>
      <Suspense fallback={null}>
        <FooterSection />
      </Suspense>
    </>
  );
}

export default App;
